export var ChartSortingType;
(function (ChartSortingType) {
    ChartSortingType["id"] = "id";
    ChartSortingType["collateralRatio"] = "collateralRatio";
})(ChartSortingType || (ChartSortingType = {}));
export var TrovesFilterType;
(function (TrovesFilterType) {
    TrovesFilterType["above"] = "above";
    TrovesFilterType["below"] = "below";
})(TrovesFilterType || (TrovesFilterType = {}));
